import '/modules/common/css/ui/warnings.css';
import '/modules/common/css/ui/warnings.responsive.css';
import '/modules/common/css/ui/warnings.mobile.css';

import {UIElement} from "./ui";

/**
 * A panel that shows warning messages and marks them as read on panel close
 */
class WarningMessagesPanel extends UIElement {

    /**
     * @param warningMessages {Array<WarningMessageConfig>}
     * @param serviceWarningMessages {Array<ServiceWarningMessageConfig>}
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(warningMessages, serviceWarningMessages, onChangeRuntimeConfig) {
        super('warning_messages_panel', onChangeRuntimeConfig);
        this.warningMessages = warningMessages;
        this.serviceWarningMessages = serviceWarningMessages;
        this.visibleServiceNames = {};
        this.onCloseCallbacks = [];
        this.onShowCallbacks = [];
        this.onWarningsChangeCallbacks = [];
    }

    getClassName() {
        return "WarningMessagesPanel";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $(
                '<section aria-controls="warnings_close_button" class="warning-messages-panel"><header><h2>'+tumbo.translator.translate('warning.title')+'</h2></header>' +
                '   <div class="warning-messages-panel-container" aria-live="polite">' +
                '      <div class="top"></div>' +
                '      <ul role="list" class="general"></ul>' +
                '      <ul role="list" class="service"></ul>' +
                '      <div class="no-warnings">'+tumbo.translator.translate('warning.noWarnings')+'</div>'+
                '      <div class="bottom"></div>' +
                '   </div>' +
                '   <button id="warnings_close_button" class="warnings-closer" type="button" title="' + tumbo.translator.translate('warning.closeButton') + '"></button>' +
                '</section>'
            ).attr('id', this.id);

            let wmCount = 0;
            this._getGeneralWarningMessages2Show().forEach(wm => {
                const message = wm.getMessage().replaceAll('\n', '<br/>').replaceAll('\r', '<br/>');
                $('ul.general', this.uiElement).append($('' +
                    '<li role="listitem">' +
                    '   <h3 id="general_label_'+(++wmCount)+'">' + tumbo.translator.translate('warning.generalWarningTitle', ["" + (wmCount)]) + '</h3>' +
                    '   <div aria-labelledby="general_label_'+wmCount+'"><p>' + message + '</p>' +
                    '</li>'
                ));
            });

            if (this.hasUnreadWarningMessages()) {
                this.show();
            } else this.close();

            $('button.warnings-closer', this.uiElement).click(() => {
                this.logStat("CLOSE");
                this.close();
            });
        }
        return this.uiElement;
    }

    _rerenderServiceMessages() {
        $('ul.service', this.uiElement).empty();
        this._getVisibleServiceWarningMessages().forEach(swm => {
            const message = swm.getMessage().replaceAll('\n', '<br/>').replaceAll('\r', '<br/>');
            $('ul.service', this.uiElement).append($('' +
                '<li role="listitem">' +
                '   <h3 id="service_label_'+swm.getServiceCode()+'">' + this.visibleServiceNames[swm.getServiceCode()] + '</h3>' +
                '   <div aria-labelledby="service_label_'+swm.getServiceCode()+'"><p>' + message + '</p></div>' +
                '</li>'
            ));
        });
        if(this.hasNoWarnings()){
            $('.no-warnings',this.getUIElement()).show();
        } else {
            $('.no-warnings',this.getUIElement()).hide();
        }
    }

    hasNoWarnings() {
        return this._getVisibleServiceWarningMessages().length + this._getGeneralWarningMessages2Show().length === 0;
    }

    show() {
        this.getUIElement().show();
        this.visible = true;
        this._rerenderServiceMessages();
        this.onShowCallbacks.forEach(c => c());
    }

    close() {
        super.close();
        this.visible = false;
        this.getUIElement().hide();
        this._getGeneralWarningMessages2Show().forEach(wm => this._markMessageRead(wm));
        this._getVisibleServiceWarningMessages().forEach(wm => this._markMessageRead(wm));
        this.onCloseCallbacks.forEach(c => c());
    }

    onClose(callback) {
        this.onCloseCallbacks.push(callback);
    }

    onShow(callback) {
        this.onShowCallbacks.push(callback);
    }

    onWarningsChange(callback){
        this.onWarningsChangeCallbacks.push(callback);
    }

    isVisible() {
        return this.visible;
    }

    _markMessageRead(message) {
        localStorage.setItem("wm_" + message.getCode(), '1');
    }

    _isMessageRead(message) {
        return localStorage.getItem("wm_" + message.getCode()) === '1';
    }

    _getGeneralWarningMessages2Show() {
        return this.warningMessages.filter(wm=>wm.shouldBeShown());
    }

    _getUnreadWarningMessages() {
        return this._getGeneralWarningMessages2Show().filter(wm => !this._isMessageRead(wm));
    }

    _getServiceWarningMessages2Show() {
        return this.serviceWarningMessages.filter(wm=>wm.shouldBeShown());
    }

    _getUnreadServiceWarningMessages() {
        return this._getServiceWarningMessages2Show().filter(wm => !this._isMessageRead(wm) && this.visibleServiceNames[wm.getServiceCode()]);
    }

    _getVisibleServiceWarningMessages() {
        return this._getServiceWarningMessages2Show().filter(wm => this.visibleServiceNames[wm.getServiceCode()]);
    }

    hasUnreadWarningMessages() {
        return this._getUnreadWarningMessages().length > 0 || this._getUnreadServiceWarningMessages().length > 0;
    }


    /**
     * To be called when the visible layers change
     * @param visibleLayers {Array<Layer>} The currently visible layers
     */
    onChangeVisibleLayers(visibleLayers) {
        this.visibleLayers = visibleLayers;
        this._onChangeVisibleServices();
    }

    /**
     * To be called when the visible base layers change
     * @param visibleBaseLayers {Array<BaseLayer>} The currently visible base layers
     */
    onChangeVisibleBaseLayers(visibleBaseLayers) {
        this.visibleBaseLayers = visibleBaseLayers;
        this._onChangeVisibleServices();
    }

    /**
     * To be called when the visible context layers change
     * @param visibleContextLayers {Array<ContextLayer>} The currently visible context layers
     */
    onChangeVisibleContextLayers(visibleContextLayers) {
        this.visibleContextLayers = visibleContextLayers;
        this._onChangeVisibleServices();
    }

    _onChangeVisibleServices() {
        this.visibleServiceNames = {};

        if (this.visibleLayers)
            this.visibleLayers.forEach(l => {
                l.getAllServiceConfigs().forEach(s => this.visibleServiceNames[s.getCode()] = l.getName());
            });

        if (this.visibleBaseLayers)
            this.visibleBaseLayers.forEach(l => this.visibleServiceNames[l.getServiceConfig().getCode()] = l.getName());

        if (this.visibleContextLayers)
            this.visibleContextLayers.forEach(l => this.visibleServiceNames[l.getServiceConfig().getCode()] = l.getName());

        this._rerenderServiceMessages();
        this.onWarningsChangeCallbacks.forEach(c => c());
    }
}

/**
 * A button to open the warning messages panel
 */
class WarningsButton extends UIElement{

    /**
     * @param warningMessages {Array<WarningMessageConfig>}
     * @param serviceWarningMessages {Array<ServiceWarningMessageConfig>}
     * @param target {jQuery} The target to append this button to
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(warningMessages, serviceWarningMessages, target, onChangeRuntimeConfig) {
        super('warnings_button', onChangeRuntimeConfig);
        this.panel = new WarningMessagesPanel(warningMessages, serviceWarningMessages,onChangeRuntimeConfig);
        this.target = target;

        this.target.append(this.getUIElement());
    }

    getClassName() {
        return "WarningsButton";
    }

    getUIElement() {
        if(!this.uiElement){
            this.uiElement = $(
                '<div id="'+this.id+'" class="warnings-button-container">' +
                '   <button type="button" title="'+tumbo.translator.translate('warning.openButton')+'"></button>' +
                '</div>'
            );

            $('button',this.uiElement).click(()=>{
                if(!this.panel.isVisible()){
                    this.panel.show();
                    this.logStat("SHOW");
                }
            });
            this.panel.onClose(()=>this.getUIElement().show());
            this.panel.onShow(()=>this.getUIElement().hide());
            this.panel.onWarningsChange(()=>{
                if(this.panel.hasNoWarnings())
                    this.uiElement.hide();
                else this.uiElement.show();
            });
            this.target.append(this.panel.getUIElement());
        }
        return this.uiElement;
    }

    onChangeVisibleLayers(visibleLayers) {
        this.panel.onChangeVisibleLayers(visibleLayers);
    }

    onChangeVisibleBaseLayers(visibleBaseLayers) {
        this.panel.onChangeVisibleBaseLayers(visibleBaseLayers);
    }

    onChangeVisibleContextLayers(visibleContextLayers) {
        this.panel.onChangeVisibleContextLayers(visibleContextLayers);
    }
}

export {WarningsButton}